import { createSelector } from 'reselect'
import { fullName } from './utils'

import { selectSponsorship } from './sponsorship'

import {
  getCustomerFirstName,
  getCustomerLastName,
  getCustomerPhotoUri,
  getCustomerPhone,
  getCustomerEmail,
  selectCustomerProfile,
  selectCustomerHasSponsor
} from './customerProfile'

export const selectContact = createSelector(
  selectCustomerHasSponsor,
  selectCustomerProfile,
  selectSponsorship,
  (hasSponsor, customerProfile, sponsor) => (hasSponsor ? sponsor : customerProfile)
)

const select = getter => createSelector(selectContact, getter)

export const selectContactFirstName = select(getCustomerFirstName)
export const selectContactLastName = select(getCustomerLastName)
export const selectContactPhotoUri = select(getCustomerPhotoUri)
export const selectContactPhone = select(getCustomerPhone)
export const selectContactEmail = select(getCustomerEmail)
export const selectContactFullName = createSelector(selectContactFirstName, selectContactLastName, fullName)
